<div class="main-wrapper"><v-sheet class="bookings-table-container pa-6 elevation-2"><AdminBookings :bookings="bookings"></AdminBookings></v-sheet></div>